import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const roleApi = createApi({
  reducerPath: 'roleApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['role'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getRoleList: builder.query({
      query: () => ({
        method: 'GET',
        path: `Roles/GetRoleNames`,
      }),
      providesTags: ['role'],
    }),
    getRoleSettings: builder.query({
      query: ({ id }) => ({
        method: 'GET',
        path: `Roles/GetRoleSettings/${id}`,
      }),
      providesTags: ['role'],
    }),
    getRoleFields: builder.query({
      query: () => ({
        method: 'GET',
        path: `Roles/GetRoleFields`,
      }),
      providesTags: ['role'],
    }),
    createRole: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Roles/CreateRoleName',
      }),
      invalidatesTags: ['role'],
    }),
    updateRole: builder.mutation({
      query: ({ data, id }) => ({
        data,
        method: 'PUT',
        path: `Roles/UpdateRoleName/${id}`,
      }),
      invalidatesTags: ['role'],
    }),
    deleteRole: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `Roles/DeleteRoleName/${id}`,
      }),
      invalidatesTags: ['role'],
    }),
    updateRoleSettings: builder.mutation({
      query: ({ data, id }) => ({
        data,
        method: 'POST',
        path: `Roles/CreateRoleSettings/${id}`,
      }),
      invalidatesTags: ['role'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const roleApiReducerName = roleApi.reducerPath;
export const roleApiReducer = roleApi.reducer;
export const roleApiMiddleware = roleApi.middleware;

export const {
  useGetRoleListQuery,
  useGetRoleSettingsQuery,
  useLazyGetRoleSettingsQuery,
  useGetRoleFieldsQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
  useUpdateRoleSettingsMutation,
} = roleApi;
